import { memo, useEffect, useState } from "react";
import PropTypes from "prop-types";
import SmartDPProduct from "app/pages/SmartDP/Listing/SmartDPProduct/SmartDPProduct";
import Loader from "app/pages/.shared/Loader";
import "./SmartDPProductList.scss";
import { PushNotificationContainer } from "app/pages/.shared/PushNotification/PushNotificationContainer";
import { useIntersectionObserver } from "app/hooks";
import { useFilterParam } from "app/features/product/productFilters";
import { SDP_PRODUCTS_FILTERS_KEY } from "app/constants";

const HOTELS_PER_CHUNK = 12;
const SDP_FILTERS = Object.values(SDP_PRODUCTS_FILTERS_KEY);

const SmartDPProductList = ({
	accommodationsList = [],
	spotlightAccommodationId,
	onAccommodationClick,
	quotationItems = [],
	isStopOver = false,
}) => {
	const [visibleCount, setVisibleCount] = useState(HOTELS_PER_CHUNK);
	const { filters } = useFilterParam(SDP_FILTERS);

	const visibleProducts = accommodationsList.slice(0, visibleCount);
	const hasMoreToShow = accommodationsList.length > visibleCount;

	const [loadMoreRef, loadMoreRefVisible] = useIntersectionObserver({
		rootMargin: "0px 0px 600px 0px",
	});

	useEffect(() => {
		if (!loadMoreRefVisible) {
			return;
		}

		if (hasMoreToShow) {
			setVisibleCount(prev => prev + HOTELS_PER_CHUNK);
		}
	}, [loadMoreRefVisible, hasMoreToShow]);

	useEffect(() => {
		setVisibleCount(HOTELS_PER_CHUNK);
	}, [filters]);

	return (
		<div className="sdp-product-list">
			<ul className="sdp-product-list__list" data-testid="sdp-product-list">
				{visibleProducts.map((accommodation, index) => (
					<li
						key={accommodation?.id}
						className="sdp-product-list__list-item"
						data-testid="sdp-product-list-item"
					>
						<SmartDPProduct
							position={index}
							isSpotlight={String(accommodation?.id) === spotlightAccommodationId}
							onClick={onAccommodationClick}
							accommodation={accommodation}
							quotationItems={quotationItems}
							isStopOver={isStopOver}
							subgrid
						/>
					</li>
				))}
			</ul>
			<div ref={loadMoreRef} />

			{hasMoreToShow && (
				<div className="sdp-product-list__item-loader">
					<Loader />
				</div>
			)}

			<PushNotificationContainer />
		</div>
	);
};

SmartDPProductList.propTypes = {
	accommodationsList: PropTypes.array,
	spotlightAccommodationId: PropTypes.string,
	onAccommodationClick: PropTypes.func,
	quotationItems: PropTypes.array,
	isStopOver: PropTypes.bool,
};

export default memo(SmartDPProductList);
